var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodbo7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4676_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9499 9.47876H20.6297L14.0103 19.0735C13.6086 19.6521 12.9414 20 12.2288 20H7.69125L14.9464 9.48242H14.9499V9.47876ZM19.2115 5.00366H3L5.19367 7.53784C5.90278 8.38745 6.44071 8.85986 7.03804 9.05029H20.9266L21.0035 8.93677V6.76514C21.0035 5.79102 20.2001 5 19.2115 5H19.215L19.2115 5.00366Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4676_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    fill: "white",
    transform: "translate(3 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodbo7);
export default __webpack_public_path__ + "static/media/codbo7.97e90df64bbbf491f499c9b72670e384.svg";
export { ForwardRef as ReactComponent };